@if (showFloatingActionButton) {
	<stages-floating-action-menu [iconClass]="'ico ico-add'" [menuItems]="menuItems" [darkTheme]="true" [card]="card" />
}
